package com.downdogapp.client.api

import com.downdogapp.client.api.AppType.*
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Platform.ANDROID
import com.downdogapp.client.singleton.Platform.IOS
import com.downdogapp.client.singleton.Platform.WEB

fun getManifestUrl() = when (App.platform) {
  WEB -> "/manifest"
  ANDROID, IOS -> buildString {
    append("https://")
    append(
      when (App.appType) {
        ORIGINAL -> "www"
        INTRO -> "intro"
        HIIT -> "hiit"
        BARRE -> "barre"
        SEVEN -> "seven"
        PRENATAL -> "prenatal"
        MEDITATION -> "meditation"
        RUNNING -> "running"
        BREATHING -> "breathing"
        PILATES -> "pilates"
      }
    )
    // append("beta") // uncomment to use beta
    append(".downdogapp.com/manifest")
  }
  // Used to point to local backend from a mobile device - see instructions here:
  // https://github.com/bsimon36/downdogapp/wiki/Pointing-at-your-local-server-while-testing-the-app-on-a-phone
}
